import EventBus from './../wirebox/event-bus'
import jQuery from 'jquery'
import 'basictable'

const StackableTable = {
    
    run () {
        
        let
            table,
            breakpoint
        
        jQuery('.stacktable').each((i, element) => {
            
            table = jQuery(element)
            breakpoint = table.data('breakpoint')
            
            table.basictable({
                breakpoint: breakpoint ? breakpoint : 991,
                forceResponsive: true
            })
            
        })
        
    },
    
    bindEvents() {
        
        //Run utility
        EventBus.subscribe('run-modules', this.run)
    
    }
    
};

StackableTable.bindEvents()

export default StackableTable